import { render, staticRenderFns } from "./Requirementlist.vue?vue&type=template&id=a67c352c&scoped=true&"
import script from "./Requirementlist.vue?vue&type=script&lang=js&"
export * from "./Requirementlist.vue?vue&type=script&lang=js&"
import style0 from "./Requirementlist.vue?vue&type=style&index=0&id=a67c352c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67c352c",
  null
  
)

export default component.exports